import script from "./Pagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pagination.vue?vue&type=script&lang=ts&setup=true"

import "./Pagination.vue?vue&type=style&index=0&id=dfd83b5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd83b5a"]])

export default __exports__